export default {
  userInfo: { steam: {} },
  userAssets: {}
}